import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window back to the top on every pathname change.
 *
 * Without this, React Router preserves the previous page's scroll
 * position when navigating, which surprises users — e.g. clicking a
 * team-member card after scrolling down on the list keeps you at the
 * bottom of the new page instead of showing the rep's name at the top.
 *
 * Mount this once inside <BrowserRouter>.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // `instant` matches typical PWA navigation; smooth would feel sluggish
    // when jumping between dense pages on mobile.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
